export default __webpack_public_path__ + "static/media/schedule-grey.a4013eaf.svg";